import { ID_DATA } from '~/js/constants/data-element-ids'

export const isApp = () => {
  const dataElement = document.getElementById(ID_DATA)
  const userAgentsAppString = dataElement.dataset.userAgentsApp || ''
  const userAgentsApp = userAgentsAppString.split(',')
  const userAgent = globalThis.navigator.userAgent

  return userAgentsApp.some(
    (userAgentApp) => userAgent.indexOf(userAgentApp) != -1
  )
}

export const isMobile =
  globalThis.matchMedia &&
  globalThis.matchMedia('(max-device-width: 640px)').matches
